const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const request = async (path, options = {}) => {
  const res = await fetch(`${API}${path}`, { headers: { "Content-Type": "application/json" }, ...options });
  const data = await res.json().catch(() => ({ detail: `Server error ${res.status} — please try again` }));
  if (!res.ok) throw new Error(Array.isArray(data.detail) ? data.detail.map(d => `${d.loc?.slice(-1)[0]}: ${d.msg}`).join(", ") : data.detail || "Request failed");
  return data;
};

export const api = {
  dashboard: symbol => request(`/dashboard?symbol=${encodeURIComponent(symbol)}`),
  search: q => request(`/search?q=${encodeURIComponent(q)}`),
  scanner: () => request("/scanner"),
  strategy: () => request("/strategy"),
  saveStrategy: body => request("/strategy", { method: "POST", body: JSON.stringify(body) }),
  growwStatus: () => request("/groww/status"),
  connect: access_token => request("/groww/connect", { method: "POST", body: JSON.stringify({ access_token }) }),
  connectTotp: (totp_token, totp_secret) => request("/groww/connect-totp", { method: "POST", body: JSON.stringify({ totp_token, totp_secret }) }),
  refreshToken: () => request("/groww/refresh", { method: "POST" }),
  disconnect: () => request("/groww/disconnect", { method: "POST" }),
  setMode: live => request("/mode", { method: "POST", body: JSON.stringify({ live }) }),
  placeOrder: body => request("/orders", { method: "POST", body: JSON.stringify(body) }),
  orders: () => request("/orders"),
};
